RivalIQ.apps.PostRegistration.module('views', function (views, App, Backbone, Marionette, $, _, moment) {
    'use strict';

    const MAX_WAIT_SECONDS = 2 * 60;
    const MIN_WAIT_SECONDS = 5;
    const REDIRECT_LOCATION = '/overview';
    const LOADING_TEXT = 'Loading...';
    const CONTINUE_TEXT = 'Get Started';
    const INDUSTRY_ACCOUNT_GROUP_IDS = [80];

    views.CompaniesPage = Marionette.LayoutView.extend({
        template: '#postRegistrationCompaniesTemplate',

        ui: {
            progressBar: '.progress-bar',
            continueBtn: '.continue-btn',
            continueBtnWrapper: '.continue-btn-container',
            timeRemaining: '.time-remaining'
        },

        regions: {
            matrixRegion: '.companies-matrix-region'
        },

        events: {
            'click @ui.continueBtn': 'onContinueClicked'
        },

        initialize: function () {
            const me = this;

            me.startTime = Date.now();

            me.listenTo(RivalIQ.apps.SocialChannelMatrix, 'userEdit:start', me.onUserEdit);
            me.listenTo(RivalIQ.apps.SocialChannelMatrix, 'userEdit', me.onUserEditFinished);
        },

        onBeforeShow: function () {
            const me = this;

            me.showSocialChannelMatrix();
        },

        onShow: function () {
            const me = this;
            me.pollCompanies();
        },

        onUserEdit: function () {
            const me = this;
            // restart the timeout
            me.startTime = Date.now();
            me.pollCompanies();
        },

        onUserEditFinished: function () {
            const me = this;
            me.updateProgress(me.getProgress());
        },

        getDisplayPercent: function (percentComplete) {
            const me = this;
            const delta = Math.floor((Date.now() - me.startTime) / 1000);
            let remaining = 0;
            let percentRemaining = 100;
            if (percentComplete < 100) {

                remaining = MAX_WAIT_SECONDS - delta;
                me.remainingSeconds = (remaining > 0 ? remaining : 0);
                const timeoutPercent = (100 - Math.floor(me.remainingSeconds / MAX_WAIT_SECONDS * 100));
                percentRemaining = percentComplete + Math.floor((100 - percentComplete) * (timeoutPercent / 100));

            } else {

                remaining = MIN_WAIT_SECONDS - delta;
                me.remainingSeconds = (remaining > 0 ? remaining : 0);
                percentRemaining = (100 - Math.floor(me.remainingSeconds / MAX_WAIT_SECONDS * 100));
            }

            return percentRemaining;
        },

        updateProgress: function (percentComplete) {
            const me = this;

            let displayPercent = me.getDisplayPercent(percentComplete);
            const humanTime = `We're still loading your data - about ${moment.duration(me.remainingSeconds, 'seconds').humanize()} remaining...`;
            const doneMessage = 'Your account is ready to go!';
            let timeRemainingText = (me.remainingSeconds > 0 ? humanTime : doneMessage);
            let toolTipText = null;

            // we timed out... let them through
            if (percentComplete < 100 && me.remainingSeconds === 0) {
                timeRemainingText = 'Your account is ready to go, but data is still loading...';
                displayPercent = 100;
            } else if (percentComplete === 100 && me.remainingSeconds > 0) {
                timeRemainingText = 'Setting up your account...';
            }

            if (displayPercent < 100) {
                me.ui.continueBtn.addClass('disabled');
                me.ui.continueBtn.text(LOADING_TEXT);
                toolTipText = 'Loading last 60 days of data';
            } else {
                me.ui.continueBtn.removeClass('disabled');
                me.ui.continueBtn.text(CONTINUE_TEXT);
                toolTipText = null;
            }

            me.ui.progressBar.css('width', `${displayPercent}%`);
            me.ui.timeRemaining.text(timeRemainingText);
            me.setTooltipText(toolTipText);
        },

        pollCompanies: function () {
            const me = this;

            const api = function () {
                me.updateProgress(me.getProgress());
                return $.Deferred().resolve();
            };

            const condition = function () {
                return me.getProgress() === 100 && me.remainingSeconds === 0;
            };

            return RivalIQ.utils.polling.pollUntilCondition(api, condition, {
                skipFailFast: true
            });
        },

        getProgress: function () {
            const companies = RivalIQ.state.landscape.get('companies');
            let finished = 0;
            const total = companies.size();

            companies.each(function (company) {
                if (!company.stillFinding() && !company.stillWaitingForUserEdit()) {
                    finished += 1;
                }
            });

            return (finished > 0 ? Math.floor(finished / total * 100) : 0);
        },

        showSocialChannelMatrix: function () {
            const me = this;

            const view = new RivalIQ.apps.SocialChannelMatrix.views.MatrixList({
                hideActions: true,
                is1xux: true,
                noCheckboxes: true,
                dashboardModel: new Marionette.Dashboard.models.Model()
            });
            view.loadData()
                .done(function () {
                    me.matrixRegion.show(view);
                });

        },

        onCompaniesComplete: function () {
            const me = this;

            me.ui.progressBar.removeClass('in-progress');
            me.ui.completeBtn.removeClass('disabled');
            me.ui.completeBtn.text(CONTINUE_TEXT);
        },

        onContinueClicked: function () {
            const me = this;
            const isStillLoading = me.getProgress() < 100;

            RivalIQ.execute('tracking:push:auth', 'V3RegistrationEnteredApp', {
                isStillLoading: isStillLoading
            });
            window.location = REDIRECT_LOCATION;
        },

        hasIndustry: function () {
            return _.includes(INDUSTRY_ACCOUNT_GROUP_IDS, RivalIQ.state.account.get('groupId'));
        },

        getIndustryNames: function () {
            // assumes the current landscape is the competitive landscape and any
            // others in the account at post-registration are are industry landscapes
            const competitiveLandscapeId = RivalIQ.state.landscape.get('id');
            const landscapes = RivalIQ.state.user.get('landscapes');

            return _.reduce(landscapes, (memo, {id, name}) => (
                id === competitiveLandscapeId ? memo : memo.concat(name)
            ), []);
        },


        templateHelpers: function () {
            const me = this;

            return {
                hasIndustry: me.hasIndustry(),
                industryNames: me.getIndustryNames(),
                industryDescription: 'Save time and start benchmarking right out of the box with this curated industry landscape. Uncover the content, consumer, and product trends happening across your industry.'
            };
        },

        setTooltipText: function (text) {
            const me = this;

            if (!text) {
                me.ui.continueBtnWrapper.tooltip('destroy');
            } else {
                me.ui.continueBtnWrapper
                    .attr('title', text)
                    .tooltip('fixTitle')
                    .tooltip({
                        container: 'body',
                        trigger: 'hover'
                    });
            }
        }

    });
}, window.moment);
